export default __webpack_public_path__ + "static/media/elec.7b90a70e.png";